<app-modal [id]="modalId" [maskClose]="false">
  <aside class="modal confirm-modal">
    <div class="modal-body">
      <div class="header" [ngClass]="{modalCode: titleCode}">
        <p class="title">{{titleCode}}</p>
        <div class="button regular close" (click)="cancel()"><span class="icon">&#x00D7;</span></div>
      </div>
      <div class="content" >
        @if (code) {
          <div class="code">
            <span>{{code}}</span>
          </div>
        }
        @if (text) {
          <p class="title">{{text}}</p>
        }
        @if (subText) {
          <p class="subtitle">{{subText}}</p>
        }
      </div>
      <div class="footer">
        @if (!hideButtonText) {
          <button class="button regular solid-green"  (click)="upgrade()">{{buttonText}}</button>
        }
        @if (learnMoreButton) {
          <p (click)="learnMore()">Learn More</p>
        }
      </div>
    </div>
  </aside>
  <div class="confirm-modal-background"></div>
</app-modal>
